import React, { useState, useEffect } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaAd,
  FaVideo,
  FaGavel,
  FaMoneyBillWave,
  FaCreditCard,
  FaUserCircle,
  FaBars,
  FaWallet,
  FaTimes,
  FaLock,
  FaMicrophone,
  FaBullhorn,
  FaUsers,
  FaSignOutAlt,
  FaRocket,
  FaPlus,
  FaHistory
} from "react-icons/fa";
import ReporterHeader from './ReporterHeader';
import Swal from 'sweetalert2';
import LogoutModal from '../Common/LogoutModal';

const ReporterLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [activeMobileMenu, setActiveMobileMenu] = useState(null); // 'ads', 'conferences', null
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isProfileComplete, setIsProfileComplete] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const checkProfileCompletion = async () => {
      try {
        // const user = JSON.parse(localStorage.getItem('user'));

        let user = null;
        try {
          const userString = localStorage.getItem('user');
          user = userString ? JSON.parse(userString) : null;
        } catch (e) {
          console.error('Error parsing user from localStorage:', e);
          user = null;
        }

        // Add your profile completion criteria here
        const isComplete = user && user.name && user.email && user.phone && user.address;
        setIsProfileComplete(isComplete);
      } catch (error) {
        console.error('Error checking profile completion:', error);
        setIsProfileComplete(false);
      }
    };

    checkProfileCompletion();
  }, []);

  // Close sidebar when clicking on a link on mobile
  const handleLinkClick = () => {
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }
  };


  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
    setShowLogoutModal(false);
  };

  const menuItems = [
    {
      path: "/reporter/dashboard",
      icon: FaTachometerAlt,
      label: "Dashboard",
      gradient: "from-blue-200 to-blue-300",
      hoverGradient: "from-blue-300 to-blue-400",
      textColor: "text-blue-900"
    },
    {
      path: "/reporter/advertisement",
      icon: FaAd,
      label: " New Advertisement",
      gradient: "from-purple-200 to-purple-300",
      hoverGradient: "from-purple-300 to-purple-400",
      textColor: "text-purple-900"
    },
    // Reward Ads
    {
      path: "/reporter/freeads",
      icon: FaAd,
      label: "Mandatory Advertisement",
      gradient: "from-purple-200 to-purple-300",
      hoverGradient: "from-purple-300 to-purple-400",
      textColor: "text-purple-900"
    },
    // Free Conference
    {
      path: "/reporter/freeconference",
      icon: FaUsers,
      label: "Free Conference",
      gradient: "from-green-200 to-green-300",
      hoverGradient: "from-green-300 to-green-400",
      textColor: "text-green-900"
    },
    // Paid Conference
    {
      path: "/reporter/paidconference",
      icon: FaCreditCard,
      label: "Paid Conference",
      gradient: "from-yellow-200 to-yellow-300",
      hoverGradient: "from-yellow-300 to-yellow-400",
      textColor: "text-yellow-900"
    },
    // { 
    //   path: "/reporter/conference", 
    //   icon: FaVideo, 
    //   label: "Conference",
    //   gradient: "from-green-200 to-green-300",
    //   hoverGradient: "from-green-300 to-green-400",
    //   textColor: "text-green-900"
    // },
    // { 
    //   path: "/reporter/darbar", 
    //   icon: FaGavel, 
    //   label: "Darbar",
    //   gradient: "from-red-200 to-red-300",
    //   hoverGradient: "from-red-300 to-red-400",
    //   textColor: "text-red-900"
    // },
    // { 
    //   path: "/reporter/podcast", 
    //   icon: FaMicrophone, 
    //   label: "Podcast",
    //   gradient: "from-pink-200 to-pink-300",
    //   hoverGradient: "from-pink-300 to-pink-400",
    //   textColor: "text-pink-900"
    // },
    {
      path: "/reporter/raisevoice",
      icon: FaBullhorn,
      label: "Raise Voice",
      gradient: "from-yellow-200 to-yellow-300",
      hoverGradient: "from-yellow-300 to-yellow-400",
      textColor: "text-yellow-900"
    },

    {
      path: "/reporter/wallet",
      icon: FaWallet,
      label: "Wallet",
      gradient: "from-teal-200 to-teal-300",
      hoverGradient: "from-teal-300 to-teal-400",
      textColor: "text-teal-900"
    },
    {
      path: "/reporter/cards",
      icon: FaCreditCard,
      label: "Apply ID Card",
      gradient: "from-cyan-200 to-cyan-300",
      hoverGradient: "from-cyan-300 to-cyan-400",
      textColor: "text-cyan-900"
    },

    //get my id card
    {
      path: "/reporter/getidcard",
      icon: FaCreditCard,
      label: "My ID Card",
      gradient: "from-yellow-200 to-yellow-300",
      hoverGradient: "from-yellow-300 to-yellow-400",
      textColor: "text-yellow-900"
    },
    {
      path: "/reporter/account",
      icon: FaUserCircle,
      label: "My Profile",
      gradient: "from-indigo-200 to-indigo-300",
      hoverGradient: "from-indigo-300 to-indigo-400",
      textColor: "text-indigo-900"
    },
    // change password
    {
      path: "/reporter/settings",
      icon: FaLock,
      label: "Change Password",
      gradient: "from-red-200 to-red-300",
      hoverGradient: "from-red-300 to-red-400",
      textColor: "text-red-900"
    }




  ];

  const sections = [
    {
      title: "🏠 Main",
      titleColor: "text-blue-600",
      items: [
        { path: "/reporter/dashboard", icon: FaTachometerAlt, label: "Dashboard", gradient: "from-blue-500 to-blue-600", iconColor: "text-blue-500" }
      ]
    },
    {
      title: "📰 Leads & Content",
      titleColor: "text-purple-600",
      items: [
        { path: "/reporter/advertisement", icon: FaAd, label: "Advertisement", gradient: "from-purple-500 to-purple-600", iconColor: "text-purple-500" },
        { path: "/reporter/freeads", icon: FaAd, label: "Reward Ads", gradient: "from-pink-500 to-rose-600", iconColor: "text-pink-500" },
        { path: "/reporter/raisevoice", icon: FaBullhorn, label: "Raise Voice", gradient: "from-amber-500 to-orange-600", iconColor: "text-amber-500" }
      ]
    },
    {
      title: "🎥 Conferences",
      titleColor: "text-emerald-600",
      items: [
        { path: "/reporter/freeconference", icon: FaUsers, label: "Free Conference", gradient: "from-emerald-500 to-teal-600", iconColor: "text-emerald-500" },
        { path: "/reporter/paidconference", icon: FaCreditCard, label: "Paid Conference", gradient: "from-cyan-500 to-sky-600", iconColor: "text-cyan-500" }
      ]
    },
    {
      title: "💳 Identity & Wallet",
      titleColor: "text-indigo-600",
      items: [
        { path: "/reporter/wallet", icon: FaWallet, label: "Wallet", gradient: "from-teal-500 to-cyan-600", iconColor: "text-teal-500" },
        { path: "/reporter/cards", icon: FaCreditCard, label: "Apply ID Card", gradient: "from-indigo-500 to-violet-600", iconColor: "text-indigo-500" },
        { path: "/reporter/getidcard", icon: FaCreditCard, label: "My ID Card", gradient: "from-violet-500 to-purple-600", iconColor: "text-violet-500" }
      ]
    },
    {
      title: "⚙️ Account",
      titleColor: "text-slate-600",
      items: [
        { path: "/reporter/account", icon: FaUserCircle, label: "My Profile", gradient: "from-slate-500 to-gray-600", iconColor: "text-slate-500" },
        { path: "/reporter/settings", icon: FaLock, label: "Change Password", gradient: "from-gray-500 to-slate-600", iconColor: "text-gray-500" }
      ]
    },
    {
      title: "🔙 Exit",
      titleColor: "text-red-600",
      items: [
        { path: "/", icon: FaRocket, label: "Go Back", gradient: "from-red-500 to-rose-600", iconColor: "text-red-500" }
      ]
    }
  ];

  return (
    <div className="flex h-screen bg-[#F8FAFC] relative font-sans">
      {/* Overlay for mobile */}
      {isSidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40 transition-opacity duration-300"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Sidebar Toggle Button for Mobile */}
      {!isSidebarOpen && (
        <button
          className="lg:hidden fixed top-4 left-4 z-50 p-2.5 bg-white border border-slate-200 text-slate-600 rounded-xl shadow-sm hover:shadow-md transition-all active:scale-95"
          onClick={() => setIsSidebarOpen(true)}
        >
          <FaBars className="w-5 h-5" />
        </button>
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0
          lg:w-[260px]
          w-72 bg-white border-r border-slate-100
          transform transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)]
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0 z-50 lg:z-auto
          flex flex-col shadow-[4px_0_24px_rgba(0,0,0,0.02)]
        `}
      >
        {/* Sidebar Header */}
        <div className="h-16 flex items-center justify-between px-4 sm:px-5 shrink-0 border-b border-slate-50">
          <div className="flex items-center gap-3 overflow-hidden">
            <div className="min-w-[40px] w-10 h-10 bg-indigo-600 rounded-2xl flex items-center justify-center shadow-lg shadow-indigo-200 group transition-transform hover:scale-105 active:scale-95 cursor-pointer" onClick={() => navigate('/reporter/dashboard')}>
              <FaRocket className="w-5 h-5 text-white" />
            </div>

            <div className="animate-fadeIn whitespace-nowrap">
              <h2 className="text-sm font-black text-slate-900 tracking-tight uppercase">Iinsaf</h2>
              <p className="text-[10px] font-bold text-indigo-500 uppercase tracking-widest leading-none mt-0.5">Reporter</p>
            </div>
          </div>

          <button
            className="lg:hidden text-slate-400 hover:text-slate-600 p-2"
            onClick={() => setIsSidebarOpen(false)}
          >
            <FaTimes className="w-5 h-5" />
          </button>
        </div>

        {/* Navigation Section */}
        <nav className="flex-1 overflow-y-auto overflow-x-hidden pt-6 px-3 custom-scrollbar">
          {sections.map((section, sIdx) => (
            <div key={sIdx} className="mb-6">

              <div className="px-3 mb-2 flex items-center justify-between">
                <h3 className={`text-[10px] font-black uppercase tracking-[0.2em] ${section.titleColor} opacity-80`}>
                  {section.title}
                </h3>
              </div>

              <div className="space-y-1">
                {section.items.map((item, iIdx) => {
                  const isActive = location.pathname === item.path;
                  return (
                    <Link
                      key={iIdx}
                      to={item.path}
                      onClick={handleLinkClick}
                      className={`
                        group relative flex items-center gap-3 px-3 py-2 rounded-xl transition-all duration-300
                        ${isActive
                          ? `bg-indigo-600 text-white shadow-lg shadow-indigo-100`
                          : "text-slate-500 hover:text-indigo-600 hover:bg-slate-50"
                        }
                      `}
                    >
                      <div className={`
                        shrink-0 w-8 h-8 rounded-lg flex items-center justify-center transition-all animate-scaleUp
                        ${isActive ? "text-white" : `${item.iconColor} bg-slate-50 group-hover:bg-white`}
                      `}>
                        <item.icon className={`w-4 h-4 ${isActive ? 'drop-shadow-sm' : ''}`} />
                      </div>

                      <span className={`text-xs font-black tracking-tight flex-1 truncate transition-all ${isActive ? 'translate-x-1' : ''}`}>
                        {item.label}
                      </span>

                      {isActive && (
                        <div className="w-1.5 h-1.5 bg-white rounded-full shadow-sm animate-pulse" />
                      )}
                    </Link>
                  );
                })}
              </div>
            </div>
          ))}
        </nav>

        {/* Bottom Actions */}
        <div className="p-3 border-t border-slate-50">
          <button
            onClick={handleLogout}
            className={`
              w-full flex items-center gap-3 px-3 py-2.5 rounded-xl
              bg-rose-50 hover:bg-rose-500 text-rose-600 hover:text-white
              transition-all duration-300 font-black text-xs uppercase tracking-widest
              shadow-sm hover:shadow-md hover:shadow-rose-100 active:scale-[0.98]
            `}
          >
            <FaSignOutAlt className="w-4 h-4 shrink-0" />
            <span>Sign Out</span>
          </button>
        </div>
      </aside>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0">
        <ReporterHeader
          isProfileComplete={isProfileComplete}
          onLogout={handleLogout}
        />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-slate-50/50 p-3 sm:p-5 lg:p-8 pb-24 lg:pb-8">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Overlay for mobile bottom sub-menus - catches clicks outside to close */}
      {activeMobileMenu && !isSidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-slate-900/30 backdrop-blur-[2px] z-[55] transition-opacity duration-300"
          onClick={() => setActiveMobileMenu(null)}
        />
      )}

      {/* Mobile Professional Bottom Navigation */}
      <div className={`mobile-bottom-nav lg:hidden fixed bottom-0 left-0 right-0 z-[60] pointer-events-none transition-transform duration-300 ${isSidebarOpen ? 'translate-y-full' : 'translate-y-0'}`}>
        <div className="relative w-full bg-white border-t border-slate-100 pb-safe shadow-[0_-8px_30px_rgba(0,0,0,0.08)] pointer-events-auto z-50">
          {/* Sub-menu Hub: Advertisement - Compact Modern Tile */}
          {activeMobileMenu === 'ads' && (
            <div className="absolute bottom-[100%] inset-x-0 mx-auto mb-5 w-[calc(100vw-60px)] max-w-[280px] bg-white/90 backdrop-blur-xl rounded-[2rem] shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] border border-white/40 p-2 z-[70] flex gap-2 animate-slide-up origin-bottom">
              <button
                onClick={() => { navigate('/reporter/advertisement'); setActiveMobileMenu(null); }}
                className="flex-1 group relative flex flex-col items-center justify-center h-20 rounded-[1.5rem] bg-gradient-to-br from-indigo-500 to-indigo-700 text-white transition-all active:scale-95 shadow-md shadow-indigo-100/50"
              >
                <div className="w-9 h-9 rounded-xl bg-white/20 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
                  <FaAd className="w-5 h-5 text-white" />
                </div>
                <p className="text-[9px] font-black uppercase tracking-wider">Earn Ads</p>
                <p className="text-[6px] font-bold text-white/60 uppercase">Paid</p>
              </button>

              <button
                onClick={() => { navigate('/reporter/freeads'); setActiveMobileMenu(null); }}
                className="flex-1 group relative flex flex-col items-center justify-center h-20 rounded-[1.5rem] bg-gradient-to-br from-rose-500 to-rose-600 text-white transition-all active:scale-95 shadow-md shadow-rose-100/50"
              >
                <div className="w-9 h-9 rounded-xl bg-white/20 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
                  <FaAd className="w-5 h-5 text-white" />
                </div>
                <p className="text-[9px] font-black uppercase tracking-wider">Rewards</p>
                <p className="text-[6px] font-bold text-white/60 uppercase">Task</p>
              </button>
            </div>
          )}

          {/* Sub-menu Hub: Conferences - Compact Modern Tile */}
          {activeMobileMenu === 'conferences' && (
            <div className="absolute bottom-[100%] inset-x-0 mx-auto mb-5 w-[calc(100vw-60px)] max-w-[280px] bg-white/90 backdrop-blur-xl rounded-[2rem] shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] border border-white/40 p-2 z-[70] flex gap-2 animate-slide-up origin-bottom">
              <button
                onClick={() => { navigate('/reporter/freeconference'); setActiveMobileMenu(null); }}
                className="flex-1 group relative flex flex-col items-center justify-center h-20 rounded-[1.5rem] bg-gradient-to-br from-emerald-500 to-teal-600 text-white transition-all active:scale-95 shadow-md shadow-emerald-100/50"
              >
                <div className="w-9 h-9 rounded-xl bg-white/20 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
                  <FaUsers className="w-5 h-5 text-white" />
                </div>
                <p className="text-[9px] font-black uppercase tracking-wider">Free</p>
                <p className="text-[6px] font-bold text-white/60 uppercase">Public</p>
              </button>

              <button
                onClick={() => { navigate('/reporter/paidconference'); setActiveMobileMenu(null); }}
                className="flex-1 group relative flex flex-col items-center justify-center h-20 rounded-[1.5rem] bg-gradient-to-br from-sky-500 to-blue-600 text-white transition-all active:scale-95 shadow-md shadow-blue-100/50"
              >
                <div className="w-9 h-9 rounded-xl bg-white/20 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
                  <FaCreditCard className="w-5 h-5 text-white" />
                </div>
                <p className="text-[9px] font-black uppercase tracking-wider">Paid</p>
                <p className="text-[6px] font-bold text-white/60 uppercase">Exclusive</p>
              </button>
            </div>
          )}

          {/* Bottom Bar Icons */}
          <div className="flex items-center justify-between h-[72px] px-2 sm:px-6">
            {/* Nav Left Group */}
            <div className="flex-1 flex justify-around">
              <button
                onClick={() => { navigate('/reporter/dashboard'); setActiveMobileMenu(null); }}
                className={`flex flex-col items-center justify-center gap-1 w-12 h-12 transition-all active:scale-95 ${location.pathname.includes('dashboard') ? 'text-indigo-600' : 'text-slate-400'}`}
              >
                <FaTachometerAlt className="w-5 h-5" />
                <span className="text-[8px] font-black uppercase tracking-tighter">Home</span>
              </button>

              <button
                onClick={() => setActiveMobileMenu(activeMenu => activeMenu === 'ads' ? null : 'ads')}
                className={`flex flex-col items-center justify-center gap-1 w-12 h-12 transition-all active:scale-95 ${activeMobileMenu === 'ads' ? 'text-indigo-600 scale-110' : 'text-slate-400'}`}
              >
                <div className="relative">
                  <FaAd className="w-5 h-5" />
                  {activeMobileMenu === 'ads' && <div className="absolute -top-1 -right-1 w-2 h-2 bg-indigo-500 rounded-full ring-2 ring-white" />}
                </div>
                <span className="text-[8px] font-black uppercase tracking-tighter">Ads</span>
              </button>
            </div>

            {/* Center FAB: Raise Voice */}
            <div className="flex flex-col items-center justify-end h-full pb-1.5 px-2 min-w-[80px]">
              <div className="relative -top-3">
                <button
                  onClick={() => { navigate('/reporter/raisevoice'); setActiveMobileMenu(null); }}
                  className={`w-14 h-14 bg-gradient-to-tr from-indigo-600 to-blue-600 rounded-2xl flex items-center justify-center text-white shadow-xl shadow-indigo-200 border-4 border-white transition-all active:scale-95 ${location.pathname.includes('raisevoice') ? "scale-105 shadow-indigo-400" : ""}`}
                >
                  <FaBullhorn className="w-6 h-6" />
                </button>
              </div>
              <span className={`text-[8px] font-black uppercase tracking-tighter leading-none px-2 py-1 rounded-full border transition-all ${location.pathname.includes('raisevoice') ? 'bg-indigo-600 text-white border-indigo-600 shadow-md' : 'bg-white text-indigo-600 border-slate-100 shadow-sm'}`}>
                Raise Voice
              </span>
            </div>

            {/* Nav Right Group */}
            <div className="flex-1 flex justify-around">
              <button
                onClick={() => setActiveMobileMenu(activeMenu => activeMenu === 'conferences' ? null : 'conferences')}
                className={`flex flex-col items-center justify-center gap-1 w-12 h-12 transition-all active:scale-95 ${activeMobileMenu === 'conferences' ? 'text-indigo-600 scale-110' : 'text-slate-400'}`}
              >
                <div className="relative">
                  <FaUsers className="w-5 h-5" />
                  {activeMobileMenu === 'conferences' && <div className="absolute -top-1 -right-1 w-2 h-2 bg-indigo-500 rounded-full ring-2 ring-white" />}
                </div>
                <span className="text-[8px] font-black uppercase tracking-tighter">Confs</span>
              </button>

              <button
                onClick={() => { navigate('/reporter/getidcard'); setActiveMobileMenu(null); }}
                className={`flex flex-col items-center justify-center gap-1 w-12 h-12 transition-all active:scale-95 ${location.pathname.includes('getidcard') ? 'text-indigo-600' : 'text-slate-400'}`}
              >
                <FaCreditCard className="w-5 h-5" />
                <span className="text-[8px] font-black uppercase tracking-tighter">ID Card</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={confirmLogout}
      />
    </div>
  );
};

export default ReporterLayout;
